import { DamagedItemStatus, OrderItemStatus } from './index.types';

interface ColorInfo {
  name: string;
  status: string;
  bgrColor: string;
  color: string;
  icons?: boolean;
}

export const colors: ColorInfo[] = [
  { name: OrderItemStatus.NEW, status: OrderItemStatus.PREPARING, bgrColor: 'var(--Error-50, #FEF3F2)', color: 'var(--Error-700, #B42318)' },
  { name: OrderItemStatus.NEW, status: OrderItemStatus.DAMAGED_PREPARING, bgrColor: 'var(--Error-50, #FEF3F2)', color: 'var(--Error-700, #B42318)' },
  {
    name: OrderItemStatus.READY_FOR_PICK_UP,
    status: OrderItemStatus.READY_FOR_PICK_UP,
    bgrColor: 'var(--Warning-50, #FFFAEB)',
    color: 'var(--Warning-700, #B54708)',
  },
  {
    name: OrderItemStatus.READY_FOR_PICK_UP,
    status: OrderItemStatus.DAMAGED_READY_FOR_PICK_UP,
    bgrColor: 'var(--Warning-50, #FFFAEB)',
    color: 'var(--Warning-700, #B54708)',
  },
  { name: OrderItemStatus.DELIVERING, status: OrderItemStatus.DELIVERING, bgrColor: 'var(--Blue-light-50, #F0F9FF)', color: 'var(--Blue-light-700, #026AA2)' },
  { name: OrderItemStatus.DELIVERING, status: OrderItemStatus.DAMAGED_DELIVERING, bgrColor: 'var(--Blue-light-50, #F0F9FF)', color: 'var(--Blue-light-700, #026AA2)' },
  { name: OrderItemStatus.DELIVERED, status: OrderItemStatus.DELIVERED, bgrColor: 'var(--Success-50, #ECFDF3)', color: 'var(--Success-700, #027A48)' },
  { name: OrderItemStatus.CANCELLED, status: OrderItemStatus.CANCELLED, bgrColor: 'var(--Error-50, #FEF3F2)', color: 'var(--Error-700, #B42318)' },
  { name: OrderItemStatus.DELIVERED, status: DamagedItemStatus.DAMAGED_DELIVERED, bgrColor: 'var(--Success-50, #ECFDF3)', color: 'var(--Success-700, #027A48)' },
  { name: OrderItemStatus.CANCELLED, status: DamagedItemStatus.DAMAGED_CANCELLED, bgrColor: 'var(--Error-50, #FEF3F2)', color: 'var(--Error-700, #B42318)' },
  {
    name: 'CONFIRM_DAMAGED_ORDER',
    status: DamagedItemStatus.DAMAGED_CREATED,
    bgrColor: 'var(--Warning-50, #FFFAEB)',
    color: 'var(--Warning-700, #B54708)',
  },
];

export const buttonColors: ColorInfo[] = [
  {
    name: OrderItemStatus.READY_FOR_PICK_UP,
    status: OrderItemStatus.PREPARING,
    bgrColor: 'var(--Primary-50, #F2FBF3) !important',
    color: 'var(--Primary-700, #296C32) !important',
    icons: false,
  },
  {
    name: OrderItemStatus.READY_FOR_PICK_UP,
    status: OrderItemStatus.DAMAGED_PREPARING,
    bgrColor: 'var(--Primary-50, #F2FBF3) !important',
    color: 'var(--Primary-700, #296C32) !important',
    icons: false,
  },
  {
    name: OrderItemStatus.WAIT_FOR_PICK_UP,
    status: OrderItemStatus.READY_FOR_PICK_UP,
    bgrColor: 'var(--Base-White, #FFF) !important',
    color: 'var(--Gray-300, #D0D5DD) !important',
    icons: true,
  },
  {
    name: OrderItemStatus.WAIT_FOR_PICK_UP,
    status: OrderItemStatus.DAMAGED_READY_FOR_PICK_UP,
    bgrColor: 'var(--Base-White, #FFF) !important',
    color: 'var(--Gray-300, #D0D5DD) !important',
    icons: true,
  },
  {
    name: OrderItemStatus.DELIVERING,
    status: OrderItemStatus.DELIVERING,
    bgrColor: 'var(--Base-White, #FFF) !important',
    color: 'var(--Gray-300, #D0D5DD) !important',
    icons: true,
  },
  {
    name: OrderItemStatus.DELIVERING,
    status: OrderItemStatus.DAMAGED_DELIVERING,
    bgrColor: 'var(--Base-White, #FFF) !important',
    color: 'var(--Gray-300, #D0D5DD) !important',
    icons: true,
  },
  {
    name: OrderItemStatus.DELIVERED,
    status: OrderItemStatus.DELIVERED,
    bgrColor: 'var(--Base-White, #FFF) !important',
    color: 'var(--Gray-300, #D0D5DD) !important',
    icons: true,
  },
  {
    name: OrderItemStatus.CANCELLED,
    status: OrderItemStatus.CANCELLED,
    bgrColor: 'var(--Base-White, #FFF) !important',
    color: 'var(--Gray-300, #D0D5DD) !important',
    icons: false,
  },
  {
    name: OrderItemStatus.DELIVERED,
    status: DamagedItemStatus.DAMAGED_DELIVERED,
    bgrColor: 'var(--Base-White, #FFF) !important',
    color: 'var(--Gray-300, #D0D5DD) !important',
    icons: true,
  },
  {
    name: OrderItemStatus.CANCELLED,
    status: DamagedItemStatus.DAMAGED_CANCELLED,
    bgrColor: 'var(--Base-White, #FFF) !important',
    color: 'var(--Gray-300, #D0D5DD) !important',
    icons: false,
  },
  {
    name: 'CONFIRM_DAMAGED_ORDER',
    status: DamagedItemStatus.DAMAGED_CREATED,
    bgrColor: 'var(--Primary-50, #F2FBF3) !important',
    color: 'var(--Primary-700, #296C32) !important',
    icons: false,
  },
];
